import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

export default {
  verificarAssinatura: async (texto, documento) => {
    const params = converterObjetoFormData({
      texto,
      documento,
    });

    return Vue.http.post('/api/verificarAssinatura/verificarAssinaturas', params);
  }
}


// WEBPACK FOOTER //
// ./FrontEnd/modulos/verificar-assinaturas/servico.js